import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { Role } from './role.model';
import { RoleInterface } from './role.interface';
import { RoleFactory } from './role.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class RoleService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<Role>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<RoleInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/roles`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => RoleFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getRegisterAll(params: HttpParams): Observable<Array<Role>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<RoleInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/roles-register`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => RoleFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<Role> {
        return this.http
            .get<RoleInterface>(`${environment.apiUrl}/v${environment.apiVersion}/roles/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => RoleFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(role: Role): Observable<any> {
        if (role.id) {
            return this.http
                // tslint:disable-next-line:max-line-length
                .put(`${environment.apiUrl}/v${environment.apiVersion}/roles/${role.id}`, role, { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/roles`, role, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }

    updateRole(rowId: string, roleId: string, value: boolean): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/roles/${rowId}`, { roleId, value }, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/roles/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<Role>> {
        return this.http
            .get<RoleInterface[]>(`${this.api}/roles/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawRole => RoleFactory.fromObject(rawRole)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/settings/roles/shared/role.service.ts